import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useLayoutEffect, useRef, useState } from 'react';
import { fitChipsToWidth, hiddenChipsLabel } from '../../utils/fitChipsToWidth';
import { Tooltip } from '../Tooltip';
import { Typography } from '../Typography';
import styles from './MultiAutocomplete.module.scss';
import { MultiAutocompleteChip } from './MultiAutocompleteChip';
export function MultiAutocompleteChips(param) {
    let { labels, ids, onRemove, chipTestId, overflowTestId } = param;
    const hostRef = useRef(null);
    const measureRef = useRef(null);
    const [visibleCount, setVisibleCount] = useState(labels.length);
    useLayoutEffect(()=>{
        const host = hostRef.current;
        const measure = measureRef.current;
        if (host == null || measure == null) return;
        const refit = ()=>{
            const [counter, ...chips] = Array.from(measure.children);
            setVisibleCount(fitChipsToWidth({
                widths: chips.map((chip)=>chip.getBoundingClientRect().width),
                counterWidth: counter.getBoundingClientRect().width,
                available: host.getBoundingClientRect().width
            }));
        };
        refit();
        const observer = new ResizeObserver(refit);
        observer.observe(host);
        return ()=>observer.disconnect();
    }, [
        labels
    ]);
    const overflowCount = labels.length - visibleCount;
    return /*#__PURE__*/ _jsxs("div", {
        ref: hostRef,
        className: styles.chipsHost,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                ref: measureRef,
                className: styles.chipsMeasure,
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.overflowCounter,
                        children: "+".concat(labels.length)
                    }),
                    labels.map((label, index)=>/*#__PURE__*/ _jsx("span", {
                            className: styles.designChip,
                            children: label
                        }, ids[index]))
                ]
            }),
            labels.slice(0, visibleCount).map((label, index)=>/*#__PURE__*/ _jsx(MultiAutocompleteChip, {
                    label: label,
                    onRemove: ()=>onRemove(ids[index]),
                    testId: chipTestId(ids[index])
                }, ids[index])),
            overflowCount > 0 && /*#__PURE__*/ _jsx(Tooltip, {
                title: hiddenChipsLabel({
                    labels,
                    visibleCount
                }),
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph3",
                    className: styles.overflowCounter,
                    testId: overflowTestId,
                    children: "+".concat(overflowCount)
                })
            })
        ]
    });
}
